import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetKybEvaluationsRequestSchema,
  TGetKybEvaluationsResponseSchema,
} from "./getKybEvaluations.schema";

export const getKybEvaluations = (axios: IAxiosInstance) => {
  return async (params: TGetKybEvaluationsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetKybEvaluationsResponseSchema>
    >("/api/kyb/evaluations", { params });

    return response.data;
  };
};
